import APIClient from "../client";
import { ApiMediaDetail, ApiMediaRequest } from "../types";

export const createMedia = (client: APIClient, payload: ApiMediaRequest) => {
  return client.post<ApiMediaDetail>("/media", payload);
};

export const createSignedUploadUrl = (client: APIClient, mediaUuid: string) => {
  return client.post<string>(`/media/${mediaUuid}/upload`, { mediaUuid });
};

export const endpoints = {
  createMedia,
  createSignedUploadUrl,
};
